export const OVERVIEW_PANEL_EVENTS_CATEGORIES_IDS = {
    EVENTS_CATEGORY_ID: 'events',
};
